module.exports = __webpack_public_path__ + "img/18-1.5b822a4c.jpg";